import { defineStore } from 'pinia';

export const useOptionsStore = defineStore('options', {
    state: () => ({
        roles: [],
        plans: [],
        statuses: [],
        provinces: [],
        tireBrands: [],
        customerOptions: [],
        binOptions: [],
        storageOptions: [],
        tireSetOptions: [],
        twoFactorMethods: [],
        securityQuestionTemplates: [],
        securityCheckpoint: false,
    }),
    actions: {
        reset() {
            this.$reset();
        },
    },
    getters: {
        roleOptions: (state) => {
            return state.roles;
        },

        planOptions: (state) => {
            return state.plans;
        },

        provinceOptions: (state) => {
            return state.provinces.map((province) => ({
                label: province.name,
                value: province.id,
            }));
        }
    }
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useOptionsStore.acceptHMRUpdate);
}
